import { render, staticRenderFns } from "./ParticipantDetailModal.vue?vue&type=template&id=db4d74d8&scoped=true"
import script from "./ParticipantDetailModal.vue?vue&type=script&lang=js"
export * from "./ParticipantDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4d74d8",
  null
  
)

export default component.exports